import { SubrentalCutoffEnums } from "src/app/enum/subrental-cutoff-enums";
export class SubrentalCutoffModel {
  subrentalCutoffId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  dateSubrentalCutoff: Date = new Date();
  observation: string | null = null;
  subrentalCutoffStateId: number = SubrentalCutoffEnums.open;
  liquidationStateId: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}